<template>
  <div style="margin:20px">

    <div v-if="!standalone">
      <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
        <span style="font-size: 26px; font-weight: bold">Planned - Vehicle Utilization Monthly</span><br/>
        <span style="font-style: italic; font-size: 18px">count of vehicles scheduled by type each day, click the vehicle type to filter results, switch between Booked and Available vehicle modes</span>
        <span style="float:right; margin-right: 10px; font-weight: bold; font-size: 18px;"><a target="_blank" :href="'./#/vehicle-util-monthly-tbn/' + this.tenant_id">standalone mode</a></span>
      </div>
    </div>
    <div v-if="standalone">
      <span style="font-size: 20px; font-weight: bold; margin-bottom: 10px;" class="d-flex align-items-center justify-content-center">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;Vehicle Utilization Monthly&nbsp;
      </span>
    </div>

    <div style="position: relative; font-size: 20px; font-weight: bold;" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;|&nbsp;&nbsp;Overnight Offset: &nbsp;<b-form-select v-model="selected_hours_offset" :options="hours_offset_options" style="font-size: 18px; font-weight: bold; width:100px"/>
      <span v-if="type_mappings" class="align-right d-flex align-items-center justify-content-center">
        &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="type_mode" :options="type_mode_options" style="font-weight: bold;width:150px"></b-form-select>
      </span>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="vehicle_mode" :options="vehicle_mode_options" style="font-weight: bold;width:110px"></b-form-select>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button size="md" variant="success" @click="download">Download</b-button>
    </div>
    <br/>
    <div v-if="!loading">
      <div class="row" style="margin:10px; font-weight: bold; font-size: 16px;">
        <template v-for="(type_stat, idx) in summary.vehicle_type_stats">
          <div v-if="selected_types.indexOf(type_stat.type) > -1" @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color, 'border': '2px solid red' }">{{type_stat.total_cnt}} - {{type_stat.type}} [{{type_stat.count}}]</div>
          <div v-else @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color }">{{type_stat.total_cnt}} - {{type_stat.type}} ({{type_stat.count}})</div>
<!--          <div v-if="idx == (summary.vehicle_type_stats.length/2)">!!!<br clear="left"/>!!!</div>-->
        </template>
      </div>
      <br/>
      <div style="overflow-x: auto; width: 100%;">
      <!-- Calendar Week Headers -->
      <div class="align-right d-flex" style='display: flex; flex-wrap: nowrap; margin-bottom: 5px; min-width: 980px;'>
        <div v-for="dayName in ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']" :key="dayName" style="flex: 0 0 auto; width: calc(100% / 7); min-width: 140px; text-align: center; font-weight: bold; font-size: 18px; padding: 5px;">{{dayName}}</div>
      </div>
      <template v-for="(week, weekIdx) in calendarWeeks">
        <div :key="'week-' + weekIdx" class="align-right d-flex" style='display: flex; flex-wrap: nowrap; min-width: 980px;'>
          <template v-if="vehicle_mode=='available'">
            <div v-for="day_idx in weekDayIndices" :key="'available-' + weekIdx + '-' + day_idx" :style="week[day_idx] ? 'flex: 0 0 auto; width: calc(100% / 7); min-width: 140px; border: 1px solid black; margin-top:5px' : 'flex: 0 0 auto; width: calc(100% / 7); min-width: 140px; border: 1px solid #ccc; margin-top:5px; background-color: #f9f9f9; min-height: 100px;'">
              <template v-if="week[day_idx]">
                <div style="background-color: #ddd; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{week[day_idx].date_month}}/{{week[day_idx].date_day}} - {{week[day_idx].date_weekday}}</div>
                <div style="background-color: #eee; font-weight: bold; font-size:16px; text-align:center">{{get_vis_day_count(week[day_idx])}} Total</div>
                <template v-if="!week[day_idx].subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in week[day_idx].type_cnts">
                  <div v-if="type_cnt.available_cnt > 0" style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForVehicleID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isVehiclesVisible')"><b>{{type_cnt.type | trim(20)}} [{{type_cnt.available_cnt}}/{{type_cnt.total_cnt}}]</b></div>
                  <div :style="type_cnt.isVehiclesVisible ? 'background: hsla(120,100%,75%,0.1); border: 1px dotted darkgrey; margin: 5px 5px 5px 25px;' : 'display:none'" v-if="item.vehicle_type == type_cnt.type" v-for="(item, idx) in week[day_idx].available">
                      <b>{{item.vehicle}}</b>
                  </div>
                </template>
                <template v-if="week[day_idx].subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in week[day_idx].type_cnts">
                  <div v-if="type_cnt.available_cnt > 0" style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForVehicleID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isSubtypesVisible')"><b>{{type_cnt.type | trim(20)}} [{{type_cnt.available_cnt}}/{{type_cnt.total_cnt}}]</b></div>
                  <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="subtype.parent_type === type_cnt.type" v-for="(subtype, idx) in week[day_idx].subtype_cnts">
                      <div v-if="subtype.available_cnt > 0" style="padding: 4px; margin: 5px 5px 5px 15px; font-size: 14px" :style='getStyleForVehicleID(type_cnt.colorcode)' v-on:click="toggle_div(subtype,'isVehiclesVisible')">
                        <b>{{subtype.type}} [{{subtype.available_cnt}}/{{subtype.total_cnt}}]</b>
                      </div>
                      <div :style="subtype.isVehiclesVisible ? 'background: hsla(120,100%,75%,0.1); border: 1px dotted darkgrey; margin: 5px 5px 5px 25px;' : 'display:none'" v-if="assn.vehicle_subtype === subtype.type" v-for="(assn, idx) in week[day_idx].available">
                        <b>{{assn.vehicle}}</b>
                      </div>
                  </span>
                  <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="!type_exists(type_cnt.type,week[day_idx].subtype_cnts) && assn.vehicle_type == type_cnt.type" v-for="(assn, idx) in week[day_idx].available">
                    <div @click="toggle_div(assn,'isVisible')" style="background: hsla(120,100%,75%,0.1); border: 1px dotted darkgrey; margin: 5px 5px 5px 25px;">
                      <b>{{assn.vehicle}}</b>
                    </div>
                  </span>
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            <div v-for="day_idx in weekDayIndices" :key="'booked-' + weekIdx + '-' + day_idx" :style="week[day_idx] ? 'flex: 0 0 auto; width: calc(100% / 7); min-width: 140px; border: 1px solid black; margin-top:5px' : 'flex: 0 0 auto; width: calc(100% / 7); min-width: 140px; border: 1px solid #ccc; margin-top:5px; background-color: #f9f9f9; min-height: 100px;'">
              <template v-if="week[day_idx]">
                <div style="background-color: #ddd; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{week[day_idx].date_month}}/{{week[day_idx].date_day}} - {{week[day_idx].date_weekday}}</div>
                <div style="background-color: #eee; font-weight: bold; font-size:16px; text-align:center">{{get_vis_day_count(week[day_idx])}} Total</div>
                <template v-if="!week[day_idx].subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in week[day_idx].type_cnts">
                  <div v-if="type_cnt.cnt > 0" style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForVehicleID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isVehiclesVisible')"><b>{{type_cnt.type | trim(20)}} [{{type_cnt.cnt}}/{{type_cnt.total_cnt}}]</b></div>
                  <span :style="type_cnt.isVehiclesVisible ? '' : 'display:none'" v-if="item.vehicle_type == type_cnt.type" v-for="(item, idx) in week[day_idx].assignments">
                      <div @click="toggle_div(item,'isVisible')" style="border: 1px dotted darkgrey;  margin: 5px 5px 5px 25px;">
                        <span v-if="item.vehicle">
                            <b>{{item.vehicle}}</b>
                        </span>
                        <span v-else>{{item.bookingID}}</span>
                        <div v-if="item.charterID && item.isVisible">
                          <span v-if="item.vehicle"><b>BookingID:</b> {{item.bookingID}}<br/></span>
                          <span v-if="item.vehicle"><b>Vehicle:</b> {{item.vehicle}}<br/></span>
                          <b>Start:</b> {{item.start_datetime | formatDateTimeSmall(item.timezone)}}<br/>
                          <b>Finish:</b> {{item.finish_datetime | formatDateTimeSmall(item.timezone)}}
                        </div>
                      </div>
                    </span>
                </template>
                <template v-if="week[day_idx].subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in week[day_idx].type_cnts">
                  <div v-if="type_cnt.cnt > 0" style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForVehicleID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isSubtypesVisible')"><b>{{type_cnt.type | trim(20)}} [{{type_cnt.cnt}}/{{type_cnt.total_cnt}}]</b></div>
                  <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="subtype.cnt > 0 && subtype.parent_type === type_cnt.type" v-for="(subtype, idx) in week[day_idx].subtype_cnts">
                      <div style="padding: 4px; margin: 5px 5px 5px 15px; font-size: 14px" :style='getStyleForVehicleID(type_cnt.colorcode)' v-on:click="toggle_div(subtype,'isVehiclesVisible')">
                        <b>{{subtype.type}} [{{subtype.cnt}}/{{subtype.total_cnt}}]</b>
                      </div>
                      <span :style="subtype.isVehiclesVisible ? '' : 'display:none'" v-if="assn.vehicle_subtype === subtype.type" v-for="(assn, idx) in week[day_idx].assignments">
                        <div @click="toggle_div(assn,'isVisible')" style="border: 1px dotted darkgrey;  margin: 5px 5px 5px 25px;">
                          <span v-if="assn.vehicle">
                              <b>{{assn.vehicle}}</b>
                          </span>
                          <span v-else>{{assn.bookingID}}</span>
                          <div v-if="assn.charterID && assn.isVisible">
                            <span v-if="assn.vehicle"><b>BookingID:</b> {{assn.bookingID}}<br/></span>
                            <span v-if="assn.vehicle"><b>Vehicle:</b> {{assn.vehicle}}<br/></span>
                            <b>Start:</b> {{assn.start_datetime | formatDateTimeSmall(assn.timezone)}}<br/>
                            <b>Finish:</b> {{assn.finish_datetime | formatDateTimeSmall(assn.timezone)}}
                          </div>
                        </div>
                      </span>
                  </span>
                  <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="!type_exists(type_cnt.type,week[day_idx].subtype_cnts) && assn.vehicle_type == type_cnt.type" v-for="(assn, idx) in week[day_idx].assignments">
                    <div @click="toggle_div(assn,'isVisible')" style="border: 1px dotted darkgrey;  margin: 5px 5px 5px 25px;">
                      <span v-if="assn.vehicle">
                          <b>{{assn.vehicle}}</b>
                      </span>
                      <span v-else>{{assn.bookingID}}</span>
                      <div v-if="assn.charterID && assn.isVisible">
                        <span v-if="assn.vehicle"><b>BookingID:</b> {{assn.bookingID}}<br/></span>
                        <span v-if="assn.vehicle"><b>Vehicle:</b> {{assn.vehicle}}<br/></span>
                        <b>Start:</b> {{assn.start_datetime | formatDateTimeSmall(assn.timezone)}}<br/>
                        <b>Finish:</b> {{assn.finish_datetime | formatDateTimeSmall(assn.timezone)}}
                      </div>
                    </div>
                  </span>
                </template>
              </template>
            </div>
          </template>
          </div>
        <br/>
      </template>
      </div>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>

</template>
<script>
import {get_tbn_vehicle_type_calendar, api_url} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'planned_vehicle_types_monthly_tbn',

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: false,
      standalone: false,
      vehicle_mode: 'booked',
      type_mode: 'grouped',
      type_mappings: false,
      selected_hours_offset: '',
      type_mode_options: [
        { text: 'All Types', value: 'all' },
        { text: 'Custom Types', value: 'grouped' },
      ],
      vehicle_mode_options: [
        { text: 'Booked', value: 'booked' },
        { text: 'Available', value: 'available' },
      ],
      hours_offset_options: [
        { value: '0', text: 'None' },
        { value: '1', text: '1AM' },
        { value: '2', text: '2AM' },
        { value: '3', text: '3AM' },
        { value: '4', text: '4AM' },
        { value: '5', text: '5AM' },
        { value: '6', text: '6AM' },
      ],
      // details_fromDate: justDate(moment().subtract(1, 'days')),
      // details_toDate: justDate(moment().add(1, 'days')),
      details_fromDate: justDate(moment().startOf('month')),
      details_toDate: justDate(moment().endOf('month')),
      selected_types: [],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
    this.load_data()
  },
  methods: {
    type_exists(type, subtypes) {
      for (const subtype of subtypes){
        if (type === subtype.parent_type)
          return true;
      }
      return false
    },
    async check_features() {
      if (this.$route.path.indexOf('/vehicle-util-monthly-tbn/') == -1) {
        this.standalone = false
        this.tenant_id = this.user.tenant
      }
      else if (this.$route.path.indexOf('/vehicle-util-monthly-tbn/') != -1) {
        this.standalone = true
        this.tenant_id = this.$route.path.split('/vehicle-util-monthly-tbn/')[1]
      }
    },
    filter_by_type(type) {
      let idx = this.selected_types.indexOf(type)
      if (idx > -1) {
        this.selected_types.splice(idx, 1);
      } else {
        this.selected_types.push(type)
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async load_data() {

      this.loading = true
      try {
        const { value: { data = [] }} = await get_tbn_vehicle_type_calendar(this.tenant_id, this.type_mode, this.selected_hours_offset, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.selected_hours_offset = this.summary.hours_offset
        this.type_mappings = this.summary.type_mappings
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    getStyleForVehicleID(color) {
      if (color != null)
        return 'border-radius: 10px; background-color:' + color
      return '';
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'month').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'month').endOf('month').format('MM-DD-YYYY');
    },
    get_vis_day_count(day)  {
      if (!day) return 0;
      if (this.vehicle_mode === 'available') {
        const typeRows = day.type_cnts || [];
        if (this.selected_types.length === 0) {
          return typeRows.reduce((sum, tc) => sum + (tc.available_cnt || 0), 0);
        }
        return typeRows
          .filter(tc => this.selected_types.indexOf(tc.type) !== -1)
          .reduce((sum, tc) => sum + (tc.available_cnt || 0), 0);
      }
      const list = this.vehicle_mode === 'available' ? (day.available || []) : (day.assignments || []);
      if (this.selected_types.length == 0)
        return list.length;
      return list.filter(item => this.selected_types.indexOf(item.vehicle_type) != -1).length;
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}tbn/reports/planned/vehicle/utilization/monthly/download`,
          {
            tenant: this.tenant_id,
            type_mode: this.type_mode,
            hours_offset: this.selected_hours_offset,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            vehicle_mode: this.vehicle_mode,
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        // Extract just the tenant name part (before the ID suffix like "759g468f")
        // If tenant_id is "anderson-759g468f", we want just "anderson"
        const tenant_name = this.tenant_id.split('-').length > 1 ? this.tenant_id.split('-')[0] : this.tenant_id
        link.setAttribute(
            'download',
            `vehicle-utilization-monthly-${this.vehicle_mode}-${tenant_name}-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    weekDayIndices() {
      // Return array of weekday indices [0,1,2,3,4,5,6] for Sunday-Saturday
      return [0, 1, 2, 3, 4, 5, 6]
    },
    calendarWeeks() {
      // Flatten all day records from items chunks
      const allDays = []
      if (this.items && Array.isArray(this.items)) {
        this.items.forEach(chunk => {
          if (Array.isArray(chunk)) {
            chunk.forEach(day => {
              if (day) allDays.push(day)
            })
          }
        })
      }

      if (allDays.length === 0) return []

      // Get the year from the date range
      const fromDate = moment(this.details_fromDate, 'MM-DD-YYYY')
      const year = fromDate.year()

      // Sort days by their actual date to ensure correct order
      const sortedDays = allDays.slice().sort((a, b) => {
        const dateA = moment(`${a.date_month}/${a.date_day}/${year}`, 'MM/DD/YYYY')
        const dateB = moment(`${b.date_month}/${b.date_day}/${year}`, 'MM/DD/YYYY')
        return dateA - dateB
      })

      if (sortedDays.length === 0) return []

      const weeks = []
      let currentWeek = Array(7).fill(null)

      sortedDays.forEach(day => {
        const date = moment(`${day.date_month}/${day.date_day}/${year}`, 'MM/DD/YYYY')
        if (!date.isValid()) return
        const weekdayNum = date.day()
        if (weekdayNum < 0 || weekdayNum > 6) return

        if (weekdayNum === 0 && currentWeek.some(d => d !== null)) {
          weeks.push([...currentWeek])
          currentWeek = Array(7).fill(null)
        }
        currentWeek[weekdayNum] = day
        if (weekdayNum === 6) {
          weeks.push([...currentWeek])
          currentWeek = Array(7).fill(null)
        }
      })

      if (currentWeek.some(d => d !== null)) {
        weeks.push(currentWeek)
      }

      return weeks
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    type_mode(){
      this.selected_types = []
      this.load_data()
    },
    details_toDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_fromDate = justDate(moment(this.details_toDate, 'MM-DD-YYYY').startOf('month'))

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        this.details_fromDate = moment(this.details_toDate, 'MM-DD-YYYY').subtract(1, 'month').format('MM-DD-YYYY');
      }
    },
    details_fromDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY')) {
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').endOf('month'))
      }

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        // alert("please limit tag based date range to 31 days or less")
        this.details_toDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(1, 'month').format('MM-DD-YYYY');
        // this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').endOf('month'))
      }
    },
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: steelblue !important }
</style>
